module.exports = __webpack_public_path__ + "static/media/empty-data.d0fabe06.png";